import { render, staticRenderFns } from "./TicimaxIcon.vue?vue&type=template&id=05219cc7"
import script from "./TicimaxIcon.vue?vue&type=script&lang=js"
export * from "./TicimaxIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports